import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { SyndicationSourceModel } from "@/types/service/reviews/syndicationSource.model";

type SyndicationSourceProps = {
    syndicationSource?: SyndicationSourceModel;
};

export const SyndicationSource = ({
    syndicationSource
}: SyndicationSourceProps) => {
    const { t } = useGranite();

    if (!isDefined(syndicationSource)) return null;

    return (
        <p
            className={cn(
                "tw:border tw:border-black tw:rounded-sm tw:p-2 tw:mt-2"
            )}
        >
            {t("product.reviews.review.source.originallyPostedOn")}{" "}
            {syndicationSource.name}
        </p>
    );
};
